<template>
	<BaseInput
		ref="BaseInput"
		v-model="model"
		:disabled="disabled"
		:error-message="errorMessage"
		:is-toggleable="isToggleable"
		:label="label"
		:max-number="maxNumber"
		:maxlength="maxlength"
		:min-number="minNumber"
		:name="label"
		:placeholder="getPlaceholder"
		:required="required"
		:validation="validation"
	>
		<template #default="slotProps">
			<textarea
				ref="textarea"
				v-model="model"
				:disabled="slotProps.disabled"
				:placeholder="getPlaceholder"
				:maxlength="maxlength"
				class="w-full rounded p-3 border border-gray-400 break-normal"
				:class="textAreaClass"
				@blur="validate"
				@focus="$emit('focus', $event)"
				@focusout="$emit('focusout', $event)"
			/>
		</template>
	</BaseInput>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';

export default {
	name: 'BaseTextarea',
	mixins: [Validate],
	components: { BaseInput },
	inheritAttrs: false,
	props: {
		label: { required: true },
		errorMessage: {},
		validation: {},
		required: {},
		placeholder: {},
		disabled: {},
		maxlength: {},
		value: {},
		minNumber: {},
		maxNumber: {},
		isToggleable: { default: false },
		textAreaClass: {},
		filterOnly: { default: false },
	},
	methods: {
		replaceAtSelected(replace, cursorOffset = 0) {
			const textarea = this.getTextareaElement;
			const startPos = textarea.selectionStart;
			const endPos = textarea.selectionEnd;
			const tmpStr = textarea.value;
			const firstPart = tmpStr.substring(0, startPos);
			const secondPart = tmpStr.substring(endPos, tmpStr.length);

			this.model = firstPart + replace + secondPart;
			this.focus(startPos + (cursorOffset || replace.length));
		},
		focus(selectionStart, selectionEnd) {
			this.getTextareaElement.focus();

			if (selectionStart) {
				if (!selectionEnd) {
					selectionEnd = selectionStart;
				}

				this.$nextTick(() => {
					this.getTextareaElement.setSelectionRange(selectionStart, selectionEnd);
				});
			}
		},
	},
	computed: {
		getTextareaElement() {
			return this.$refs['textarea'];
		},
		getPlaceholder() {
			return this.placeholder || this.label;
		},
		model: {
			get() {
				return this.value;
			},
			set(v) {
				if (!this.filterOnly) {
					this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
				}
				this.$emit('input', v);
			},
		},
	},
};
</script>
<style scoped></style>
